<template>
  <div class="main-wrapper h-auto w-full block md:flex justify-center">
    <div class="hs-wrapper">
      <img
        class="main-img"
        :src="`${mediaFolderUrl}images/${pageImages[imagePos]}.jpg`"
        :alt="`${pageImages[imagePos]}`"
      />
      <transition-group name="fadeDownBig" appear>
        <div
          v-for="(hotspot, index) in hotspots"
          tabindex="0"
          @keyup.enter="
            hotspots[index].isTooltip
              ? $emit('navigateTo', hotspots[index].navPos)
              : '',
              hotspots[index].isAction ? (action = true) : (action = false),
              hotspots[index].isVideo ? (video = true) : (video = false),
              (hotspots[index].animation = ''),
              closeOthers(index),
              submitEventToData($event)
          "
          class="absolute"
          :id="hotspots[index].id"
          :style="`animation-duration: 2s; animation-delay: 0.${index - 1}s`"
          :key="index + 0"
          :class="[
            hotspots[index].class,
            hotspots[index].animation,
            (imagePos > 0 && hotspots[index].isAction == false) ||
            (imagePos > 0 && hotspots[index].isTooltip) ||
            (imagePos > 0 && hotspots[index].isVideo)
              ? 'invisible-spot'
              : '',
          ]"
          @click.prevent="
            hotspots[index].isTooltip
              ? $emit('navigateTo', hotspots[index].navPos)
              : '',
              hotspots[index].isAction ? (action = true) : (action = false),
              hotspots[index].isVideo ? (video = true) : (video = false),
              (hotspots[index].animation = ''),
              closeOthers(index),
              submitEventToData($event)
          "
          v-hotspot="{ top: hotspots[index].top, left: hotspots[index].left }"
          @focus="
            hotspots[index].isTooltip ? (hotspots[index].hover = true) : '', AF;
            hotspots[index].isAction ? (action = true) : (action = false),
              hotspots[index].isVideo ? (video = true) : (video = false),
              (hotspots[index].animation = ''),
              closeOthers(index);
          "
          @blur="hotspots[index].hover = false"
          @mouseenter="
            hotspots[index].isTooltip ? (hotspots[index].hover = true) : ''
          "
          @mouseleave="hotspots[index].hover = false"
        >
          <transition mode="out-in" name="zoom">
            <div
              @mouseenter="
                hotspots[index].isTooltip ? (hotspots[index].hover = false) : ''
              "
              :class="hotspots[index].tooltipClass"
              style="animation-duration: 0.1s; animation-delay: 0.02s"
              class="tt-wrapper"
              v-if="hotspots[index].hover"
            >
              <p class="p-2 text-white font-thin text-xs">
                {{ translatePayload(hotspots[index].tooltipText) }}
              </p>
            </div>
          </transition>

          <transition mode="out-in" name="zoom">
            <div
              :class="hotspots[index].modalClass"
              style="animation-duration: 0.2s"
              class="modal-wrapper"
              v-if="hotspots[index].modal"
            >
              <p v-if="modalBody" class="text-white pt-6 pb-3 px-6 heading">
                {{ translatePayload(hotspots[index].mTitle) }}
              </p>
              <p
                v-if="modalBody"
                class="text-white pb-6 px-6 whitespace-pre-line"
              >
                {{ translatePayload(hotspots[index].mBody) }}
              </p>
              <div v-if="video" class="video-thumb-wrapper px-6 pb-6">
                <img
                  id="video"
                  @click="openVideo(index), (hotspots[index].hover = false)"
                  :src="`${mediaFolderUrl}thumbnails/${hotspots[index].videoThumb}.jpeg`"
                />
              </div>

              <div class="flex flex-1 justify-end items-center">
                <div
                  class="flex flex-1 flex-row justify-center items-center"
                  v-if="action"
                >
                  <div
                    v-for="page,index in pageImages"
                    :key="i"
                    class="indicator mx-4"
                    :class="{ active: imagePos == index }"
                  ></div>
                </div>

                <div>
                  <button
                    tabindex="-1"
                    @click.stop="
                      (hotspots[index].modal = false),
                        (hotspots[index].hover = false),
                        (imagePos = 0),
                        (modalBody = true)
                    "
                    class="btn dark text-white self-end text-sm"
                    id="dismiss"
                    @click="submitEventToData($event)"
                  >
                    Dismiss
                  </button>
                  <a
                    tabindex="0"
                    @keyup.enter="
                      actionChanger(),
                        (hotspots[index].hover = false),
                        submitEventToData($event)
                    "
                    @click="
                      actionChanger(),
                        (hotspots[index].hover = false),
                        submitEventToData($event)
                    "
                    v-if="action"
                    class="btn text-white self-end text-sm"
                    id="next"
                    >Next</a
                  >
                </div>
              </div>
            </div>
          </transition>
          <svg
            v-if="hotspots[index].plusIcon"
            xmlns="http://www.w3.org/2000/svg"
            width="12"
            height="12"
            viewBox="0 0 12 12"
          >
            <path
              id="icon-plus"
              d="M7,1A1,1,0,1,0,5,1V5H1A1,1,0,1,0,1,7H5v4a1,1,0,1,0,2,0V7h4a1,1,0,1,0,0-2H7Z"
              fill="#000"
            />
          </svg>
          <svg
            v-if="hotspots[index].vidIcon"
            xmlns="http://www.w3.org/2000/svg"
            width="7.196"
            height="8.103"
            viewBox="0 0 7.196 8.103"
          >
            <g id="uniE95F" transform="translate(0 -0.011)">
              <path
                id="Path"
                d="M0,1.03A1.118,1.118,0,0,1,.032.757.7.7,0,0,1,.144.517.981.981,0,0,1,.768.037a.924.924,0,0,1,.768.112L6.689,3.174A1.015,1.015,0,0,1,7.161,4.31a.953.953,0,0,1-.472.624L1.536,7.959a1.209,1.209,0,0,1-.24.1.907.907,0,0,1-.272.04A.976.976,0,0,1,.3,7.8a1,1,0,0,1-.3-.72Z"
                transform="translate(0 0.011)"
                fill="#000"
              />
            </g>
          </svg>
          <span v-if="hotspots[index].infoIcon">i</span>
        </div>
      </transition-group>
    </div>

    <transition mode="out-in" name="fade">
      <div
        v-if="videoEnvoked"
        class="video-modal-wrapper flex justify-center items-center"
      >
        <div class="video-modal-inner-wrapper flex justify-center items-center">
          <video
            width="100%"
            autoplay
            controls="true"
            :src="`${mediaFolderUrl}videos/${videoPlayerURL}`"
            class="fluid-video"
          ></video>
          <div
            id="close"
            @click="(videoEnvoked = !videoEnvoked), submitEventToData($event)"
            class="close-vid text-white text-lg flex justify-center items-center px-2"
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="12"
              height="12"
              viewBox="0 0 12 12"
            >
              <path
                id="icon-cross-medium"
                d="M5.974,4.554,1.715.3A1,1,0,1,0,.3,1.713L4.567,5.976.3,10.291a1,1,0,0,0,1.41,1.42l4.274-4.32,4.3,4.3A1,1,0,1,0,11.7,10.274L7.391,5.969,11.734,1.58a.857.857,0,0,0-.1-1.319,1.166,1.166,0,0,0-1.5.1l-4.152,4.2Z"
                fill="#fff"
              />
            </svg>
          </div>
        </div>
      </div>
    </transition>
  </div>
</template>

<script>
export default {
  props: [
    "personaDataAction",
    "areWeTracking",
    "welcomePos",
    "hotspots",
    "submitEventToData",
    "pageImages",
    "mediaFolderUrl",
  ],
  data: () => {
    return {
      action: false,
      video: false,
      videoEnvoked: false,
      videoPlayerURL: "",
      imagePos: 0,
      modalBody: true,
    };
  },
  methods: {
    openVideo(index) {
      this.videoPlayerURL = this.hotspots[index].videoURL;
      this.videoEnvoked = true;
    },
    translatePayload(payload) {
      return this.$i18n.t(payload);
    },
    actionChanger() {
      if (this.imagePos < this.pageImages.length - 1) {
        this.imagePos++;
      } else {
        this.imagePos = 0;
      }
      if (this.imagePos > 0) {
        this.modalBody = false;
      } else {
        this.modalBody = true;
      }
    },
    closeOthers(index) {
      this.hotspots.forEach(function (h) {
        h.modal = false;
      });
      if (this.hotspots[index].isDialog) {
        this.hotspots[index].modal = true;
      }
      this.$emit("countReached");
    },
  },
};
</script>

<style lang="scss" scoped>
.invisible-spot {
  opacity: 0 !important;
}

.fluid-video{
  height: auto;
  max-height: 80vh;
}
.close-vid {
  height: 25px;
  width: 25px;
  background: #00a376;
  position: absolute;
  top: -15px;
  right: -15px;
  cursor: pointer;
  border: 1px solid white;
}

.hs-wrapper {
  position: relative;
}

.video-modal-wrapper {
  position: fixed;
  top: 60px;
  left: 0;
  width: 100%;
  height: calc(100vh - 60px);
  z-index: 400;
  background: #000000b0;
  & .video-modal-inner-wrapper {
    width: 70%;
    box-shadow: 0 10px 40px 0 rgba(0, 20, 29, 0.04),
      0 50px 80px 0 rgba(0, 20, 29, 0.1);
    position: relative;
    & video {
      border-radius: 2px;
      outline: none;
      position: relative;
    }
  }
}

.main-wrapper {
  box-sizing: border-box;
}

.video-thumb-wrapper {
  & img {
    box-shadow: 0 px 15px 0 rgba(0, 20, 29, 0.2),
      0 10px 10px 0 rgba(0, 20, 29, 0.1);
  }
  &:hover {
    opacity: 0.8;
    cursor: pointer;
  }
}
.indicator {
  height: 8px;
  width: 8px;
  background: #c5c5c57a;
  &.active {
    background: #ffffff;
    height: 10px;
    width: 10px;
  }
}
.modal-wrapper {
  position: absolute;
  background: #000000;
  width: 100vw;
  max-width: 300px;
  z-index: 100;
  box-shadow: 0 5px 5px 0 rgba(0, 20, 29, 0.2),
    0 10px 10px 0 rgba(0, 20, 29, 0.1);
  z-index: 99;
  &.modal-top-left {
    top: -17px;
    left: 55px;
    &::after {
      content: "";
      position: absolute;
      top: 10px;
      left: -30px;
      width: 0;
      height: 0;
      border-style: solid;
      border-width: 20px 30px 20px 0;
      border-color: transparent #000000 transparent transparent;
    }
  }
  &.modal-top-right {
    top: -17px;
    left: -332px;
    &::after {
      content: "";
      position: absolute;
      top: 10px;
      right: -30px;
      width: 0;
      height: 0;
      border-style: solid;
      border-width: 20px 0px 20px 30px;
      border-color: transparent transparent transparent #000000;
    }
  }
  &.modal-middle-right {
    left: -332px;
    &::after {
      content: "";
      position: absolute;
      top: 44.5%;
      right: -30px;
      width: 0;
      height: 0;
      border-style: solid;
      border-width: 20px 0px 20px 30px;
      border-color: transparent transparent transparent #000000;
    }
  }
  &.modal-middle-left {
    left: 55px;
    &::after {
      content: "";
      position: absolute;
      top: 44.5%;
      left: -30px;
      width: 0;
      height: 0;
      border-style: solid;
      border-width: 20px 30px 20px 0;
      border-color: transparent #000000 transparent transparent;
    }
  }
  &.modal-bottom-left {
    bottom: -17px;
    left: 55px;
    &::after {
      content: "";
      position: absolute;
      bottom: 10px;
      left: -30px;
      width: 0;
      height: 0;
      border-style: solid;
      border-width: 20px 30px 20px 0;
      border-color: transparent #000000 transparent transparent;
    }
  }

  &.modal-bottom-right {
    bottom: -67px;
    left: -332px;
    &::after {
      content: "";
      position: absolute;
      bottom: 60px;
      right: -30px;
      width: 0;
      height: 0;
      border-style: solid;
      border-width: 20px 0px 20px 30px;
      border-color: transparent transparent transparent #000000;
    }
  }
}
.tt-wrapper {
  position: absolute;
  top: -170%;
  left: -270%;
  background: #ce0058;
  width: 150px;
  border-radius: 2px;
  pointer-events: none !important;
  &.left {
    top: -30%;
    left: -700%;
  }
  &.right {
    top: -30%;
    left: 150%;
  }
  & p {
    line-height: 14px;
  }
}
.tooltips {
  height: 23px;
  width: 23px;
  background: #ce0058;
  border: 1px solid black;
  border-radius: 50%;
  cursor: pointer;
  opacity: 1;
  z-index: 49;
  box-shadow: 0 5px 4px 0 rgba(0, 20, 29, 0.2),
    0 10px 10px 0 rgba(0, 20, 29, 0.1);
  &::after {
    content: "";
    background: #ce0058;
    border-radius: 50%;
    transform: translate(-50%, -50%);
    position: absolute;
    top: 50%;
    left: 50%;
    pointer-events: none;
  }
  &.pulsing::after {
    animation: pulse infinite 3s linear;
  }
}

.dialog {
  height: 25px;
  width: 25px;
  background: #ffb500;
  border-radius: 5%;
  transition: all 0.1s linear;
  cursor: pointer;
  border: 1px solid black;
  box-shadow: 0 5px 5px 0 rgba(0, 20, 29, 0.2),
    0 10px 10px 0 rgba(0, 20, 29, 0.1);
  display: flex;
  justify-content: center;
  align-items: center;
  // &::after {
  //   content: "+";
  //   color: black;
  //    backface-visibility: hidden;
  // -webkit-backface-visibility: hidden;
  // }
  &.pulsing::before {
    content: "";
    background: #ffb500;
    transform: translate(-50%, -50%);
    position: absolute;
    top: 50%;
    left: 50%;
    animation: pulse infinite 3s linear;
  }
}

.video {
  height: 25px;
  width: 25px;
  background: #ffb500;
  border-radius: 5%;
  transition: all 0.1s linear;
  cursor: pointer;
  border: 1px solid black;
  box-shadow: 0 5px 5px 0 rgba(0, 20, 29, 0.2),
    0 10px 10px 0 rgba(0, 20, 29, 0.1);
  display: flex;
  justify-content: center;
  align-items: center;
  // &::after {
  //   content: "►";
  //   color: black;
  //   font-size: 12px;
  //   transform: translate( 0%, 8%);
  //    backface-visibility: hidden;
  // -webkit-backface-visibility: hidden;
  // }
  &.pulsing::before {
    content: "";
    background: #ffb500;
    transform: translate(-50%, -50%);
    position: absolute;
    top: 50%;
    left: 50%;
    animation: pulse infinite 3s linear;
  }
}

.main-img {
  width: 100%;
  height: auto;
  box-shadow: 0 3px 3px 0 rgba(0, 20, 29, 0.2),
    0 2px 4px 0 rgba(0, 20, 29, 0.15);
}

.btn {
  background-color: #00a376;
  border-radius: 0;
  font-weight: normal;
  text-align: center;
  padding: 15px 25px;
  display: inline-block;
  font-size: 18px;
  min-width: initial;
  cursor: pointer;
  &.dark {
    background-color: #2C3333;
  }
}

@keyframes pulse {
  0% {
    height: 0px;
    width: 0px;
    opacity: 1;
  }
  50% {
    height: 60px;
    width: 60px;
    opacity: 0;
  }
  100% {
    height: 0px;
    width: 0px;
    opacity: 0;
  }
}
@-webkit-keyframes pulse {
  0% {
    height: 0px;
    width: 0px;
    opacity: 1;
  }
  50% {
    height: 60px;
    width: 60px;
    opacity: 0;
  }
  100% {
    height: 0px;
    width: 0px;
    opacity: 0;
  }
}

@media screen and (max-width: 750px) {
  .hs-wrapper {
    width: 250%;
    height: 70vh;
    -webkit-overflow-scrolling: touch !important;
  }

  .video-modal-wrapper {
    position: fixed;
    & .video-modal-inner-wrapper {
      width: 100%;
    }
  }

  .close-vid {
    top: 0px;
    right: 0px;
  }
}
</style>
